
const createUrl = ({ name, phone_number, location_city, location_state, status }) => {
  const url = `${name ? `&name=${name}` : ''}` +
  `${phone_number ? `&phone_number=${phone_number}` : ''}` +
  `${location_city ? `&location_city=${location_city}` : ''}` +
  `${location_state ? `&location_state=${location_state}` : ''}` +
  `${status ? `&status=${status}` : ''}`

  return url
}

const createRecurringUrl = ({ origin_city, origin_state, destination_city, destination_state, equipment_type, dispatcher_name }) => {
  const url = `${origin_city ? `&origin_city=${origin_city}` : ''}` +
  `${origin_state ? `&origin_state=${origin_state}` : ''}` +
  `${destination_city ? `&destination_city=${destination_city}` : ''}` +
  `${destination_state ? `&destination_state=${destination_state}` : ''}` +
  `${equipment_type ? `&equipment_type=${equipment_type}` : ''}` +
  `${dispatcher_name ? `&dispatcher_name=${dispatcher_name}` : ''}`
  return url
}

export default {
  getMyDrivers: ({ limit = 20, offset }, body) => {
    const url = `/carrier/drivers/read?limit=${limit}&offset=${offset * limit}`
    const completeUrl = createUrl(body)
    return `${url}${completeUrl}`
  },

  addMyDriver: '/carrier/drivers/add',

  updateMyDriver: '/carrier/drivers/update',

  deleteMyDriver: (id) => `/carrier/drivers/delete?driver_id=${id}`,

  recurringTractors: '/carrier/recurring_tractors',
  getRecurringTractors: ({ limit = 20, offset, body }) => {
    const url = `/read?limit=${limit}&offset=${offset * limit}`
    const completeUrl = createRecurringUrl(body)
    return `${url}${completeUrl}`
  },
  addRecurringTractor: '/add',
  updateRecurringTractor: '/update',
  deleteRecurringTractor: (id) => `/delete?recurring_tractor_id=${id}`
}
